import PropTypes from 'prop-types';
import { DropdownWithOptions } from 'components/UI/DropdownWithOptions/DropdownWithOptions';
import './EventFiltersCheckboxes.scss';

export const EventFiltersCheckboxes = (props) => {
  const { filterSet, appliedFilters, dropdownUpdateHandler, setApplyFiltersButtonDisabled } = props;

  const optionsData = (filterSetItems) =>
    filterSetItems?.map((filterItem) => ({
      key: filterItem.Id,
      name: filterItem.Description,
    }));

  const filterTypes = filterSet.map((filterType) => {
    const { Description, Id, Term, Items, DefaultAllText } = filterType;

    // Use this as default values that are checked in Dropdown options
    const chosenValues =
      appliedFilters?.length > 0
        ? appliedFilters.find((item) => item.FilterId === Id)?.SelectedOptions
        : [];

    return (
      <div className="col-md-3" key={Id}>
        <div
          className="filter-label"
          aria-labelledby="dropdown-genre-type"
          data-testid="filter-label"
        >
          {Description}
        </div>
        <div className="dropdown">
          <DropdownWithOptions
            filterType={Term}
            filterId={Id}
            menuData={optionsData(Items)}
            defaultAllText={DefaultAllText}
            selectedCheckboxes={chosenValues}
            dropdownUpdateHandler={dropdownUpdateHandler}
            setApplyFiltersButtonDisabled={setApplyFiltersButtonDisabled}
          />
        </div>
      </div>
    );
  });

  return (
    <div className="filter-dropdowns-container" data-testid="event-filters-checkboxes">
      {filterTypes}
    </div>
  );
};

EventFiltersCheckboxes.propTypes = {
  filterSet: PropTypes.array,
  appliedFilters: PropTypes.array,
  dropdownUpdateHandler: PropTypes.func,
  setApplyFiltersButtonDisabled: PropTypes.func,
};
